import AssistenteModulosService from "@/services/AssistenteModulos";

export const assistenteModulos = {
  namespaced: true,
  state: {
    assistenteModulos: {},
  },
  actions: {
    getAssistenteModulos({ commit }, payload) {
      return AssistenteModulosService.GetAssistenteModulos(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postAssistenteModulos({ commit }, payload) {
      return AssistenteModulosService.PostAssistenteModulos(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putAssistenteModulos({ commit }, payload) {
      return AssistenteModulosService.PutAssistenteModulos(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteAssistenteModulos({ commit }, payload) {
      return AssistenteModulosService.DeleteAssistenteModulos(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getAssistenteModulosOData({ commit }, payload) {
      return AssistenteModulosService.GetAssistenteModulosOData(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default assistenteModulos;
